import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beb3d858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "content content-loading"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "queue-index" }
const _hoisted_10 = { class: "times" }
const _hoisted_11 = {
  key: 1,
  class: "content content-gaming"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "queue-index ellipsis" }
const _hoisted_15 = { class: "remaining-time" }

import { computed, reactive } from "vue";

import * as Accounts from "@js/account";
import { handleOpenGameWind } from "@js/game/game-window";
import pb from "@pb/index.json";
import { usePlayGameStore } from "@/store/playGame";
import { useLayoutDataStore } from "@/store/layoutData";
import { useloginStore } from "@/store/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingControl',
  setup(__props) {

const yunpb = pb.nested.yunpb.nested;
const PLAYERSTATUS = yunpb.PlayerStatus.values;

const playGameStore = usePlayGameStore();
const layoutDataStore = useLayoutDataStore();
const loginStore = useloginStore();

const queueData = computed(() => playGameStore.queueData);
const isLoading = computed(
  () => queueData.value.playerOper === PLAYERSTATUS.IN_QUE
);
const isQueueing = computed(() => playGameStore.isQueueing);
const isShow = computed(() => playGameStore.floatModal);
const roomInfo = computed(() => playGameStore.roomInfo);
const game = computed(() => roomInfo.value?.gameBaseInfo);
const queueLevel = computed(
  () =>
    roomInfo.value?.queueInfo?.queueLevel || yunpb.QueueLevel.values.QL_Normal
);
// 排队队列数据
const queueList = computed(() => [
  {
    level: yunpb.QueueLevel.values.QL_Normal,
    data: roomInfo.value?.normalWaitingNode,
    icon: "icon-slow",
  },
  {
    level: yunpb.QueueLevel.values.QL_Fast,
    data: roomInfo.value?.newPayWaitingNode,
    icon: "icon-fast",
  },
  {
    level: yunpb.QueueLevel.values.QL_Vip,
    data: roomInfo.value?.vipWaitingNode,
    icon: "icon-vip",
  },
]);

const position = reactive({ x: 0, y: 200 });

// 退出游戏及取消排队
const handleQuitGame = () => {
  if (!isLoading.value) {
    if (loginStore.userInfo) {
      playGameStore.exitModal = true;
      playGameStore.isExiting = true;
    }
  } else {
    // playGameStore.handleCancelBackGame();
    // 状态不一样 exitGame执行的逻辑不一样
    window.gameStateMgr.exitGame();
  }
};
// 跳转游戏窗口
const onClickCover = () => {
  if (isQueueing.value) {
    playGameStore.showQueueModal({});
  } else {
    handleOpenGameWind();
  }
};
// 拖动
const onDragEnd = (e: any) => {
  console.log("借宿", e);

  let posX = e.clientX;
  posX =
    posX < 250
      ? 0
      : posX + 250 > window.innerWidth
      ? window.innerWidth - 250
      : 0;

  let posY = e.clientY;
  posY =
    posY < 200
      ? 200
      : posY + 200 > window.innerHeight
      ? window.innerHeight - 200
      : posY;

  position.x = posX;
  position.y = posY;
};

return (_ctx: any,_cache: any) => {
  return (_unref(isShow))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({ top: `${position.y}px`, left: `${position.x}px` }),
        draggable: "true",
        onDragend: onDragEnd,
        class: "floatiingControlContainer"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: require('@/assets/img/img-float-queue.png'),
            alt: ""
          }, null, 8, _hoisted_2),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("Control.FloatingControl.inTheTime")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("Control.FloatingControl.running")), 1))
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _unref(game)?.bgPic || require('@/assets/img/login-bg.png'),
                alt: "",
                class: "poster",
                onClick: onClickCover
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "queue-type",
                  src: require(`@/assets/img/${_unref(queueList)?.[_unref(queueLevel)].icon}.png`),
                  alt: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(queueList)?.[_unref(queueLevel)].data?.num > 9999
                ? "9999+"
                : _unref(queueList)?.[_unref(queueLevel)].data?.num), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(queueList)?.[_unref(queueLevel)].data?.desc), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _unref(game)?.icon || require('@/assets/img/login-bg.png'),
                alt: "",
                class: "poster",
                onClick: onClickCover
              }, null, 8, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(game)?.gameName), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(loginStore).gameTimeRemaining), 1),
                _createElementVNode("div", {
                  onClick: handleQuitGame,
                  class: "quit active-btn",
                  title: "quit"
                }, _toDisplayString(_ctx.$t("Control.FloatingControl.Quit")), 1)
              ])
            ]))
      ], 36))
    : _createCommentVNode("", true)
}
}

})